import React, { useEffect } from "react";

import music from '../../../assets/audio/sampleAudio.wav'


const AudioPopup = ({ audioUrl, onClose }) => {
    
    const styles = {
        audioOverlay: {
          position: 'fixed',
          top: 0,
          bottom: 0,
          left: 0,
          right: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.8)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: 9999,
        },
        audio: {
          backgroundColor: 'transparent',
          padding: 20,
          position: 'relative',
          width: 'auto',
          maxWidth: '100%',
          maxHeight: '100%',
          overflow: 'auto',
          textAlign: 'center',
        },
        closeBtn: {
          position: 'absolute',
          top: 3,
          right: 0,
          fontSize: 28,
          cursor: 'pointer',
          color:'#fff'
        },
        audioPlayer: {
          width: '100%',
          height: 50,
          margin: '20px 0',
        },
        audioPlayerAudio: {
            width: '80vw',
            minWidth: 30,
            maxWidth: 500,
            height: 50,
            backgroundColor: '#f1f1f1',
            border: '1px solid #ccc',
            borderRadius:'5',
            padding: '10',
            marginBottom: "10"
        }
      }


      const handleKeyDown = (event) => {
        if (event.keyCode === 27) {
          onClose();
        }
      };
    
      useEffect(() => {
        window.addEventListener("keydown", handleKeyDown);
        return () => {
          window.removeEventListener("keydown", handleKeyDown);
        };
      }, [onClose]);


  return (
    <div style={styles.audioOverlay}>
      <div style={styles.audio}>
        <div style={styles.closeBtn} onClick={onClose}>
          &times;
        </div>
        <div style={styles.audioPlayer}>
          <audio src={audioUrl} type="audio/wav" style={styles.audioPlayerAudio} controls />
        </div>
      </div>
    </div>
  );
};

export default AudioPopup;